import { Trans, useLingui } from "@lingui/react/macro";
import { BotAvatar, Button } from "@rakazo/ui-web";
import { ArrowUpRight, CalendarDays, FileText, Lightbulb, Mail, Sparkles } from "lucide-react";
import { FALLBACK_BOT_COLOR } from "./chat-shared";

/** A quiet starting point; choosing an idea only drafts it, never sends it. */
export function ConversationWelcome({
  identity = "hrokbot-welcome",
  color = FALLBACK_BOT_COLOR,
  onChoose,
  onCreate,
}: {
  identity?: string;
  color?: string;
  onChoose?: (prompt: string) => void;
  onCreate?: () => void;
}) {
  const { t } = useLingui();
  const ideas = [
    { label: t`Plan my day`, icon: CalendarDays },
    { label: t`Write an email`, icon: Mail },
    { label: t`Explore an idea`, icon: Lightbulb },
    { label: t`Summarize a document`, icon: FileText },
  ];
  return (
    <section className="consumer-welcome" data-testid="conversation-welcome">
      <div className="consumer-companion" aria-hidden="true">
        <span className="consumer-companion-orbit" />
        <span className="consumer-companion-tile">
          <BotAvatar identity={identity} color={color} size={76} variant="robot" />
        </span>
        <Sparkles className="consumer-companion-spark" size={23} strokeWidth={1.5} />
        <span className="consumer-companion-dot" />
      </div>
      <p className="consumer-wordmark">HrokBot</p>
      <h1 className="consumer-welcome-title">
        <Trans>What would you like help with?</Trans>
      </h1>
      {onChoose ? (
        <div className="consumer-ideas">
          {ideas.map(({ label, icon: Icon }) => (
            <button
              type="button"
              key={label}
              onClick={() => onChoose(label)}
              className="consumer-idea"
            >
              <span className="consumer-idea-icon">
                <Icon size={20} strokeWidth={1.6} aria-hidden="true" />
              </span>
              <span>{label}</span>
              <ArrowUpRight className="consumer-idea-arrow" size={16} aria-hidden="true" />
            </button>
          ))}
        </div>
      ) : onCreate ? (
        <Button className="mt-7 h-12 rounded-full px-7" onClick={onCreate}>
          <Trans>Create assistant</Trans>
          <ArrowUpRight size={17} aria-hidden="true" />
        </Button>
      ) : null}
    </section>
  );
}
